import { useQuery } from 'hooks/useCustomQuery';
import getRegionByID from 'API/Region/getRegionByID';

const useGetRegion = (regionId, enabled = true) => {
    return useQuery({
        queryKey: ['Region', regionId],
        queryFn: async () => {
            const response = await getRegionByID(regionId);
            return response.data;
        },
        enabled: enabled && !!regionId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetRegion;
